export default ({ request }) => ({

  scmDictionaryListApi(data) {
    return request({
      url: '/digitalCenter/scmDictionary/list',
      method: 'post',
      data
    })
  },
  scmDictionaryOptionApi(data) {
    return request({
      url: '/digitalCenter/scmDictionary/scmDictionaryList',
      method: 'post',
      data
    })
  },
  scmDictionaryDetailApi(data) {
    return request({
      url: '/digitalCenter/scmDictionary/detail',
      method: 'post',
      data
    })
  },
  scmDictionarySaveApi(data) {
    return request({
      url: '/digitalCenter/scmDictionary/save',
      method: 'post',
      data
    })
  },
  scmDictionaryUpdateStatusApi(data) {
    return request({
      url: '/digitalCenter/scmDictionary/updateStatus',
      method: 'post',
      data
    })
  }
})
